import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { GoOverviewStepOneComponent } from './components/go-overview-step-one/go-overview-step-one.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { GoOverviewStepTwoComponent } from './components/go-overview-step-two/go-overview-step-two.component';
import { GoOverviewStepThreeComponent } from './components/go-overview-step-three/go-overview-step-three.component';
import { GoOverviewNavigationComponent } from './components/go-overview-navigation/go-overview-navigation.component';
import { GoOverviewIntroComponent } from './components/go-overview-intro/go-overview-intro.component';
import { Router } from '@angular/router';
import { RouteConstants } from '../../../../core/constants/routes';
import { fadeAnimation } from '../../../../core/animations/fade-animation';
import { AppStorageService } from '../../../../core/services/app-storage/app-storage.service';

@Component({
    selector: 'app-go-overview',
    animations: [fadeAnimation],
    imports: [
        GoOverviewIntroComponent,
        GoOverviewStepOneComponent,
        GoOverviewStepTwoComponent,
        GoOverviewStepThreeComponent,
        CommonModule,
        MatButtonModule,
        GoOverviewNavigationComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-overview.component.html',
})
export class GoOverviewComponent {
    readonly INITIAL_STEP: number = 0;
    readonly LAST_STEP: number = 3;
    readonly STEP_RANGE: number[] = Array.from(
        { length: this.LAST_STEP },
        (_, i) => i + 1,
    );

    readonly step = signal(this.INITIAL_STEP);

    constructor(
        private readonly router: Router,
        private readonly localStorageService: AppStorageService,
    ) {}

    isOnInitialStep(): boolean {
        return this.step() === this.INITIAL_STEP;
    }

    stepChange(): void {
        if (this.step() === this.LAST_STEP) {
            // Mark that the user has viewed the overview and should not be directed to it on next visit
            this.localStorageService.setHasViewedGoOverview(true);

            this.router.navigate([
                RouteConstants.Go.getFullRoute('purposeOfFiling'),
            ]);
        }

        this.step.set(this.step() + 1);
    }
}
